import React from 'react';
import PropTypes from 'prop-types';

import { MultiButtonModal } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';

export const AbusiveReferenceModal = ({ isOpen = false, toggleModal }) => (
  <MultiButtonModal
    isOpen={isOpen}
    onClose={toggleModal}
    titleText="Reference changed"
    buttons={[
      <NavigationButton.Primary label="Ok, got it" onClick={toggleModal} />,
    ]}
  >
    <StandardBody>
      The one used might offend who you’re paying. We’ve replaced it with your
      name.
    </StandardBody>
  </MultiButtonModal>
);

AbusiveReferenceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
};
